module.exports = __webpack_public_path__ + "static/img/logo61.4e73e5f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo61.png
// module id = s1ka
// module chunks = 1